import MenuQuery from 'Query/Menu.query';
import { connect } from 'react-redux';
import MenuHelper from '@scandipwa/scandipwa/src/util/Menu';

import {
    MenuContainer as SourceMenuContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceComponent/Menu/Menu.container';
import React from "react";
import Menu from "./Menu.component";

export {
    mapStateToProps,
    mapDispatchToProps,
};

export class MenuContainer extends SourceMenuContainer {
    _getMenu() {
        this.fetchData(
            [MenuQuery.getQuery({ identifier: 'new-main-menu' })],
            ({ menu }) => this.setState({ menu: MenuHelper.reduce(menu.items) }),
        );
    }

    containerProps() {
        const {
            device,
            compareTotals,
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            hideActiveOverlay,
            isActive,
            isVisible
        } = this.props;
        const { activeMenuItemsStack, menu } = this.state;

        return {
            activeMenuItemsStack,
            menu,
            device,
            compareTotals,
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            hideActiveOverlay,
            isActive,
            isVisible
        };
    }

    render() {
        return (
            <Menu
                {...this.containerProps()}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
